// src/components/student/SubjectBars.jsx
// Horizontal accuracy bar chart for each subject. Pure CSS + Framer Motion.
// Used on the Dashboard (compact) and Progress page (full size).
import React from "react";
import { motion } from "framer-motion";

const bar = (acc) =>
  acc >= 0.8 ? "bg-emerald-400" : acc >= 0.6 ? "bg-amber-400" : "bg-red-400";
const text = (acc) =>
  acc >= 0.8 ? "text-emerald-400" : acc >= 0.6 ? "text-amber-400" : "text-red-400";
const label = (acc) =>
  acc >= 0.8 ? "Mastered" : acc >= 0.6 ? "Needs Work" : "Weak";

export default function SubjectBars({ data = [], compact = false }) {
  if (!data.length) {
    return (
      <p className="text-sm text-gray-400 py-4 text-center">
        Take some quizzes and your subject breakdown will appear here.
      </p>
    );
  }

  const sorted = [...data].sort((a, b) => b.accuracy - a.accuracy);
  const rows = compact ? sorted.slice(0, 5) : sorted;

  return (
    <div className={`space-y-${compact ? "3" : "4"}`}>
      {rows.map((s, i) => {
        const pct = Math.round((s.accuracy ?? 0) * 100);
        return (
          <div key={s.subject || i}>
            <div className="flex items-center justify-between mb-1">
              <span className={`font-semibold capitalize ${compact ? "text-xs" : "text-sm"} text-gray-700`}>
                {s.subject || "Unknown"}
                {!compact && (
                  <span className="ml-2 text-xs text-gray-400 font-normal">
                    ({s.attempts} attempt{s.attempts !== 1 ? "s" : ""})
                  </span>
                )}
              </span>
              <span className={`font-bold text-xs ${text(s.accuracy)}`}>
                {pct}%
                {!compact && <span className="ml-1 text-gray-400 font-normal">· {label(s.accuracy)}</span>}
              </span>
            </div>
            <div className={`w-full bg-gray-100 rounded-full overflow-hidden ${compact ? "h-2" : "h-2.5"}`}>
              <motion.div
                className={`h-full rounded-full ${bar(s.accuracy)}`}
                initial={{ width: 0 }}
                animate={{ width: `${pct}%` }}
                transition={{ duration: 0.7, delay: i * 0.08, ease: "easeOut" }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}
